/**
 * 项目管理
 */

export default [
  {
    path: 'project/manage',
    name: '项目管理',
    component: () => import (`@/views/project/index.vue`),
  },
];

